import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { mapJustificationMessagesFieldToSobCompetitorField } from 'partner360/features/competitorsSob/helpers/mapJustificationMessagesFieldToSobCompetitorField'
import { selectCompetitorsSobState } from 'partner360/features/competitorsSob/selectors/selectCompetitorsSobState'
import { IJustificationMessage } from 'partner360/models/competitorsSob/IJustificationMessage'
import {
  applySobCompetitorsChanges,
  IApplySobCompetitorsChangesResponse,
} from 'partner360/services/competitorsSob/applySobCompetitorsChanges'

import { REQUEST_APPLY_CHANGES } from '../constants'

export interface IRequestApplySobCompetitorChangesParameters {
  fYear: number
  partnerId: string
  programType: ProgramTypes
  justificationMessages: IJustificationMessage[]
}

export const requestApplySobCompetitorChanges = createAsyncThunk<
  IApplySobCompetitorsChangesResponse,
  IRequestApplySobCompetitorChangesParameters
>(REQUEST_APPLY_CHANGES, (params, { getState }) => {
  const state = getState()
  const competitorsState = selectCompetitorsSobState(state)
  const competitors = competitorsState.data[params.programType] || []
  const updatedCompetitors = competitors.map((comp) => {
    const justificationMessages = params.justificationMessages.filter(
      (el) => el.competitorId === comp.CompetitorID && el.category === comp.NameKey
    )
    if (justificationMessages.length) {
      const fields = justificationMessages.reduce((acc, el) => {
        const field = mapJustificationMessagesFieldToSobCompetitorField(el.field)
        if (!field) {
          return { ...acc }
        }
        return { ...acc, [field]: el.message }
      }, {})

      return { ...comp, ...fields }
    }
    return { ...comp }
  })

  return applySobCompetitorsChanges({ ...params, competitors: updatedCompetitors })
})
